import { render, staticRenderFns } from "./Polkadot.vue?vue&type=template&id=7b83d56c&scoped=true&"
import script from "./Polkadot.vue?vue&type=script&lang=js&"
export * from "./Polkadot.vue?vue&type=script&lang=js&"
import style0 from "./Polkadot.vue?vue&type=style&index=0&id=7b83d56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b83d56c",
  null
  
)

export default component.exports